import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../core/library/i18n';
import { Table, Button, Switch } from 'antd';
import Moment from 'moment';
import AuthorsFilter from './../../../components/filters/authors';
import Config from './../../../config';


const ParamsLinks = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

export class RedirectsViews extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.Columns = [
            {
                title: t('TITLE'),
                dataIndex: 'title',
                sorter: true,
            },
            {
                title: t('REDIRECT_LINK'),
                key: 'slug',
				render: r => {
					return <a href={`${Config.PREVIEW_DOMAIN}/s/${r.shortCode}`} target="_blank" rel="noopener noreferrer">{`${Config.PREVIEW_DOMAIN}/s/${r.shortCode}`}</a>
				},
            },
			{
                title: t('REDIRECT_TO'),
                key: 'redirectTo',
				render: r => {
                    // let url = r.redirectTo.split('?');

                    let url = r.redirectTo ? new URL(r.redirectTo) : {href: ''};
                    if (r.options && url.href !== '') {
                        for(let i in r.options) {
                            if (ParamsLinks.indexOf(i) + 1 > 0 && r.options[i] !== '') {
                                url.searchParams.set(i, r.options[i]);
                            }
                        }
                    }


					return <a href={url.href} target="_blank" rel="noopener noreferrer">{r.redirectTo}</a>;
				}
            },
			{
                title: t('COUNT_REDIRECTS'),
                key: 'countRedirects',
				render: r => {
					return <span>{r.totalVotes || 0}</span>;
				}
            },
            {
                title: t('PUBLISHED'),
                key: 'published',
                sorter: true,
                render: row => {
                    return <Switch size="small" checked={row.published} onChange={(published) => {
                        this.props.onUpdate(row.id, { published, visible: published });
                    }} />;
                },
            },
           
            {
                title: t('UPDATED_AT'),
                key: 'updatedAt',
                sorter: true,
                render: row => Moment(row.updatedAt).format(Config.DATE_FORMAT),
            },
            {
                title: t('ACTIONS'),
                key: 'actions',
                width: 120,
                render: row => {
                    return (
                        <Button.Group>
                            <Button type={`primary`} icon={`edit`} onClick={() => {
                                this.props.onEdit(row.id);
                            }}/>
                            <Button type={`danger`} icon={`delete`} onClick={() => {
                                this.props.onDelete(row.id);
                            }}/>
                        </Button.Group>
                    );
                }
            }
        ];
    }

    componentDidMount() {
        const OptionsContext = this.props.options || {};
        if (OptionsContext.actions && OptionsContext.actions.updateHeader) {
            OptionsContext.actions.updateHeader({
                title: t('TAG_LIST'),
            })
        }
    }
    updateFilter = (search) => {
        this.props.onFilter({ search });
    };



    render() {
        return (
            <div className={`app_view_table ${this.props.type}_view`}>
                <div className="app_view--wrapper">
                    <div className={`app_view--table`}>
                        <Table
                            bordered
                            title={() => <AuthorsFilter onCreate={this.props.onCreate} onSearch={this.updateFilter} type={`Redirects`}/>}
                            dataSource={this.props.items}
                            columns={this.Columns}
                            rowKey={(item) => item.id}
                            onChange = {(pagination, filters, sorter) => {
                                let sortOrder = '-createdAt';
                                if(sorter.columnKey) {
                                    sortOrder = `${sorter.order === 'ascend' ? '' : '-'}${sorter.columnKey}`;
                                }
                                this.props.updateSort(sortOrder);
                            }}
                            pagination={{
                                pageSize: this.props.limit,
                                defaultCurrent: this.props.page,
                                total: this.props.total,
                                onChange: this.props.updatePageHandle,
                                current: this.props.page,
                                hideOnSinglePage: true,
                                showSizeChanger: true,
                                pageSizeOptions: ["30", "60", "100"],
                                onShowSizeChange: (current, size) => this.props.updateLimit(size),
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

RedirectsViews.defaultProps = {
    options: {
        actions: {
            updateHeader: () => {},
        }
    },
};

RedirectsViews.propTypes = {
    options: PropTypes.instanceOf(Object).isRequired,
};


export default RedirectsViews;
